import React from 'react'
import Threads from './Threads'

// Memoized Threads component to prevent re-renders
const MemoizedThreads = React.memo(Threads)

const OnboardingLayout = ({ children }) => {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden" style={{ backgroundColor: '#0f172a' }}>
      {/* Threads Background - Outside React's layout container */}
      <MemoizedThreads 
        color={[0.08, 0.72, 0.65]} // teal color in RGB (0-1 range)
        amplitude={1.2}
        distance={0.2}
        enableMouseInteraction={false}
      />
      
      {/* React content - Isolated from background repaints */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  )
}

export default OnboardingLayout
